var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('CustomSidebar', {
    attrs: {
      "title": _vm.selectedData ? 'Detail Adjustment Running Hours' : 'Create Adjustment Running Hours',
      "size": "xl"
    },
    model: {
      value: _vm.showCanvas,
      callback: function callback($$v) {
        _vm.showCanvas = $$v;
      },
      expression: "showCanvas"
    }
  }, [_c('div', {
    staticClass: "bg-white shadow-sm p-4",
    staticStyle: {
      "border-radius": "10px"
    }
  }, [_vm.showCanvas ? _c('FormAdjustmentRunningHours', {
    attrs: {
      "selectedData": _vm.selectedData
    },
    on: {
      "refetch": _vm.fetchData,
      "close": function close($event) {
        _vm.showCanvas = false;
      }
    }
  }) : _vm._e()], 1)]), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("ADJUSTMENT RUNNING HOUR")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$adjustments, _vm$adjustments$data, _vm$adjustments2, _vm$adjustments2$data;
        return [_c('b-row', [_c('FilterRh', {
          attrs: {
            "filters": _vm.filters
          }
        }), _c('b-col', {
          staticClass: "d-flex justify-content-end",
          attrs: {
            "md": "6"
          }
        }, [_c('b-button', {
          staticStyle: {
            "height": "max-content"
          },
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function click($event) {
              ;
              _vm.showCanvas = true, _vm.selectedData = null;
            }
          }
        }, [_vm._v(" Create Adjustment Running Hours ")])], 1), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('table', {
          staticClass: "w-100 table-striped"
        }, [_c('thead', [_c('th', [_vm._v("FLEET")]), _c('th', [_vm._v("TRANSACTION ID")]), _c('th', [_vm._v("CREATOR BY")]), _c('th', [_vm._v("EFFECTIVE DATE")]), _c('th', [_vm._v("ACTION")])]), !_vm.loading ? _c('tbody', [_vm._l(_vm.adjustments.data, function (item, i) {
          var _item$vehicle, _item$user$requestor$, _item$user, _item$user$requestor, _item$effective_date;
          return [_c('tr', {
            key: "".concat(i)
          }, [_c('td', [_c('b-badge', {
            attrs: {
              "variant": "success"
            }
          }, [_vm._v(" " + _vm._s((_item$vehicle = item.vehicle) === null || _item$vehicle === void 0 ? void 0 : _item$vehicle.name) + " ")])], 1), _c('td', [_vm._v(" TRX-ADJSRH-" + _vm._s(item === null || item === void 0 ? void 0 : item.id) + "-" + _vm._s(item !== null && item !== void 0 && item.effective_date ? _vm.moment(item === null || item === void 0 ? void 0 : item.effective_date).format('MMYYYY') : '') + " ")]), _c('td', [_vm._v(" " + _vm._s((_item$user$requestor$ = item === null || item === void 0 ? void 0 : (_item$user = item.user) === null || _item$user === void 0 ? void 0 : (_item$user$requestor = _item$user.requestor) === null || _item$user$requestor === void 0 ? void 0 : _item$user$requestor.name) !== null && _item$user$requestor$ !== void 0 ? _item$user$requestor$ : '-') + " ")]), _c('td', [_vm._v(_vm._s((_item$effective_date = item === null || item === void 0 ? void 0 : item.effective_date) !== null && _item$effective_date !== void 0 ? _item$effective_date : '-'))]), _c('td', {
            staticStyle: {
              "width": "120px"
            }
          }, [_c('b-dropdown', {
            attrs: {
              "text": "Action",
              "size": "sm",
              "variant": "outline-primary"
            }
          }, [_c('b-dropdown-item', {
            on: {
              "click": function click() {
                _vm.showCanvas = true;
                _vm.selectedData = item;
              }
            }
          }, [_vm._v(" View Detail Transaction ")]), (item === null || item === void 0 ? void 0 : item.state) == 'requested' ? [_c('b-dropdown-item', {
            on: {
              "click": function click() {
                return _vm.handleConfirm(item, 'approve');
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-thumbs-up text-success mr-1"
          }), _vm._v(" Approved ")]), _c('b-dropdown-item', {
            on: {
              "click": function click() {
                return _vm.handleConfirm(item, 'reject');
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-close text-danger mr-2"
          }), _vm._v(" Rejected ")])] : _vm._e()], 2)], 1)])];
        })], 2) : _vm._e()]), _vm.loading ? _c('div', {
          staticClass: "w-100 d-flex justify-content-center py-5"
        }, [_c('b-spinner')], 1) : _vm._e(), !_vm.loading && !((_vm$adjustments = _vm.adjustments) !== null && _vm$adjustments !== void 0 && (_vm$adjustments$data = _vm$adjustments.data) !== null && _vm$adjustments$data !== void 0 && _vm$adjustments$data.length) ? _c('div', {
          staticClass: "w-100 d-flex justify-content-center py-4"
        }, [_vm._v(" No Data Here! ")]) : _vm._e(), (_vm$adjustments2 = _vm.adjustments) !== null && _vm$adjustments2 !== void 0 && (_vm$adjustments2$data = _vm$adjustments2.data) !== null && _vm$adjustments2$data !== void 0 && _vm$adjustments2$data.length ? _c('div', {
          staticClass: "mt-4 d-flex align-items-center w-100 justify-content-between"
        }, [_c('p', {
          staticClass: "mb-0"
        }, [_vm._v(" Total Rows: "), _c('strong', {
          staticClass: "text-black"
        }, [_vm._v(_vm._s(_vm.adjustments.total))])]), _c('div', {
          staticClass: "d-flex justify-content-end"
        }, [_c('b-pagination', {
          staticClass: "mb-0 mr-3",
          attrs: {
            "total-rows": _vm.adjustments.total,
            "per-page": _vm.adjustments.perPage,
            "first-number": "",
            "align": "center"
          },
          on: {
            "change": function change(page) {
              _vm.adjustments.page = page;
              _vm.fetchData();
            }
          },
          model: {
            value: _vm.adjustments.page,
            callback: function callback($$v) {
              _vm.$set(_vm.adjustments, "page", $$v);
            },
            expression: "adjustments.page"
          }
        }), _c('b-form-select', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "plain": "",
            "options": _vm.limitOptions
          },
          on: {
            "input": _vm.fetchData
          },
          model: {
            value: _vm.adjustments.perPage,
            callback: function callback($$v) {
              _vm.$set(_vm.adjustments, "perPage", $$v);
            },
            expression: "adjustments.perPage"
          }
        })], 1)]) : _vm._e()])], 1)];
      },
      proxy: true
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }